import React, {useState, Fragment, useRef, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import NoteAddIcon from '@mui/icons-material/NoteAdd';

import {Dialog, Transition} from '@headlessui/react';
import {ExclamationTriangleIcon} from '@heroicons/react/24/outline';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import ExitForm from '../../ExitFormModal';
import CreateIcon from '@mui/icons-material/Create';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import MultiSelect from '../../Selects/MultiSelect';
import Datepicker from 'react-tailwindcss-datepicker';
import SelectComponent from '../../Selects/SelectComponent';
import {useContext} from 'react';
import {Context} from '../../../Helpers/Auth';

function DrawerFilter({
    showForm,
    setShowForm,
    setButtonClicked,
    setButtonClickedEdit,
    setSalvarEdicao,
    setButtonClickedSalvar,
    buttonClickedSalvar,
    editDespesa,
    setEditDespesa,
    buttonClickedEdit,
    onChangeForm,
    setOnChangeForm,

    filtroCodigo,
    setFiltroCodigo,
    filtroUtilizador,
    setFiltroUtilizador,
    filtroData,
    setFiltroData,
    filtroNome,
    setFiltroNome,
    filtroValor,
    setFiltroValor,
    filtroDespesa,
    setFiltroDespesa,
    filtroEstado,
    setFiltroEstado,
    utilizadores,
    estados,
    tipoDespesas,
}) {
    const {t} = useTranslation();
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const cancelButtonRef = useRef(null);
    const [openExit, setOpenExit] = useState(false);

    const {isCard, setIsCard, openCards, setOpenCards} = useContext(Context);
    const [isMobile, setIsMobile] = useState(false);
    const handleAdicionarDespesa = () => {
        setButtonClicked(true);
    };
    const handleResize = () => {
        setIsMobile(window.innerWidth < 900);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleEditarDespesa = () => {
        setButtonClickedEdit(true);
        setButtonClickedSalvar(true);
    };

    const handleSalvarEdicaoDespesa = () => {
        setSalvarEdicao(true);
    };

    const [state, setState] = useState({
        right: false,
    });

    const toggleDrawer = (anchor, open) => event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({...state, [anchor]: open});
    };
    const closeDrawer = anchor => {
        setState({...state, [anchor]: false});
    };

    const list = anchor => (
        <ClickAwayListener onClickAway={() => closeDrawer(anchor)}>
            <Box sx={{width: 320}} role="presentation" className="h-full  bg-white w-80 dark:bg-gray-800">
                <h5 id="drawer-label" className="inline-flex p-4 items-center mb-6 text-base font-semibold text-blue-600 uppercase dark:text-blue-600">
                    <FilterAltIcon className="mr-2" />
                    {t('filtros')}
                </h5>
                <button
                    type="button"
                    data-drawer-hide="drawer-contact"
                    aria-controls="drawer-contact"
                    onClick={() => closeDrawer(anchor)}
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-blue-600 rounded-[8px] text-sm w-8 h-8 absolute top-2.5 right-2.5 inline-flex items-center justify-center dark:hover:bg-blue-600 dark:hover:text-white">
                    <CloseIcon />
                    <span className="sr-only">Close menu</span>
                </button>

                <div className="mb-6 p-4">
                    <div className="relative mt-4">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                            </svg>
                        </div>
                        <input
                            type="search"
                            id="default-search"
                            value={filtroCodigo}
                            className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-white focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder={t('filtroCodigo')}
                            onChange={e => {
                                setFiltroCodigo(e.target.value);
                            }}
                        />
                    </div>
                    <div className="relative mt-4">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                            </svg>
                        </div>
                        <input
                            type="search"
                            id="default-search"
                            value={filtroNome}
                            className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-white focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder={t('filtroNome')}
                            onChange={e => {
                                setFiltroNome(e.target.value);
                            }}
                        />
                    </div>
                    <div className="relative mt-4">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                            </svg>
                        </div>
                        <input
                            type="search"
                            id="default-search"
                            value={filtroValor == 0 ? '' : filtroValor}
                            className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-white focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder={t('filtroValor')}
                            onChange={e => {
                                setFiltroValor(e.target.value);
                            }}
                        />
                    </div>

                    <div className=" mt-4">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('data')}
                        </label>
                        <Datepicker
                            displayFormat="DD/MM/YYYY"
                            // maxDate={today}
                            useRange={false}
                            asSingle={true}
                            value={filtroData}
                            onChange={newValue => {
                                setFiltroData(newValue);
                            }}
                            inputClassName={`rounded-[8px] w-full bg-white border border-gray-300 text-lg text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                        />
                    </div>
                    <div className=" mt-4">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('utilizador')}
                        </label>
                        <MultiSelect
                            isMulti
                            options={utilizadores}
                            value={filtroUtilizador.value}
                            onChange={e => {
                                setFiltroUtilizador(e);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('filtro')}
                        />
                    </div>
                    <div className=" mt-4">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('tipoDespesa')}
                        </label>
                        <SelectComponent
                            options={tipoDespesas}
                            value={filtroDespesa ? filtroDespesa.label : ''}
                            onChange={e => {
                                setFiltroDespesa({
                                    id: e.value,
                                    tipo: e.label,
                                });
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('filtro')}
                        />
                    </div>
                    <div className=" mt-4">
                        <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('estado')}
                        </label>
                        <SelectComponent
                            options={estados}
                            value={filtroEstado}
                            onChange={e => {
                                setFiltroEstado({
                                    value: e.value,
                                    label: e.label,
                                });
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('filtro')}
                        />
                    </div>
                </div>
            </Box>
        </ClickAwayListener>
    );

    function handleShowForm(showForm, open) {
        if (showForm) {
            if (!open) {
                setOpen(true);
            }
        } else {
            setShowForm(true);
        }
    }

    async function botaoEditarGuardar() {
        if (editDespesa) {
            if (buttonClickedSalvar) {
                handleSalvarEdicaoDespesa();
            } else {
                handleEditarDespesa();
            }
        } else {
            handleAdicionarDespesa();
        }
    }

    return (
        <>
            {' '}
            <div className="flex flex-row items-center">
                {!showForm && (
                    <>
                        {!isMobile && (
                            <>
                            
                                <div className="flex items-center mr-3">
                                    <label className="relative inline-flex items-center cursor-pointer">
                                        <input type="checkbox" checked={isCard} onChange={() => setIsCard(!isCard)} className="sr-only peer" />
                                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                        <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('modoCard')}</span>
                                    </label>
                                </div>
                            </>
                        )}
                        {isCard && (
                            <div className="flex items-center mr-3">
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <input type="checkbox" checked={openCards} onChange={() => setOpenCards(!openCards)} className="sr-only peer" />
                                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                    <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('abrirCards')}</span>
                                </label>
                            </div>
                        )}
                    </>
                )}
                <div className="inline-flex mb-4 rounded-[8px] shadow-sm" role="group">
                    {!showForm && (
                        <button
                            title={t('filtros')}
                            type="button"
                            onClick={toggleDrawer('right', true)}
                            className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-200 rounded-l-[8px] hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white">
                            <FilterAltIcon />
                        </button>
                    )}
                    <button
                        type="button"
                        title={showForm ? t('voltar') : t('criarDespesa')}
                        className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10   ${
                            showForm ? ' dark:bg-blue-700 text-blue-700 focus:ring-blue-700 focus:ring-2 rounded-l-[8px]' : 'dark:bg-gray-700 text-gray-500 rounded-r-[8px]'
                        } dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white`}
                        onClick={() => {
                            if (showForm) {
                                if (onChangeForm) {
                                    setOpenExit(true);
                                    // setOnChangeForm(false);
                                } else {
                                    setShowForm(false);
                                    setEditDespesa(false);
                                    // setOnChangeForm(false);
                                }
                            }
                            handleShowForm(showForm);
                        }}>
                        {!showForm && <NoteAddIcon />}
                        {showForm && <KeyboardBackspaceRoundedIcon />}
                    </button>
                    {showForm && (
                        <button
                            title={editDespesa ? (buttonClickedEdit ? t('salvarMudancas') : t('editar')) : t('salvar')}
                            type="submit"
                            onClick={() => {
                                botaoEditarGuardar();
                            }}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border rounded-r-[8px] border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white`}>
                            {editDespesa ? buttonClickedEdit ? <SaveAsIcon /> : <CreateIcon /> : <SaveIcon />}
                        </button>
                    )}
                </div>
            </div>
            <Drawer anchor="right" open={state['right']} onClose={toggleDrawer('right', false)}>
                {list('right')}
            </Drawer>
            {openExit && (
                <ExitForm
                    cancelar={() => setOpenExit(false)}
                    back={() => {
                        setShowForm(false);
                        setOpenExit(false);
                        setEditDespesa(false);
                    }}
                />
            )}
        </>
    );
}

export default DrawerFilter;
